export default "__VITE_ASSET__3258a938__"